import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addServiceUnits = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/method/technoerp.services.create_service_unit',
    body
  );
  return data;
});
export const deleteServiceUnits = catchAsync(async (id) => {
  const { data } = await axiosInstance.delete(
    `/api/method/technoerp.services.delete_record?record=${id}&document=Healthcare Service Unit`
  );
  return data;
});

export const getServiceUnits = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_service_units'
  );
  return data;
});
export const getServiceUnitTypes = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_service_unit_types'
  );
  return data;
});
export const getWarehouses = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_warehouses'
  );
  return data;
});
export const getItemGroups = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_item_groups'
  );
  return data;
});
export const getServiceUnitsDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.get_service_units?patient=${id}`
  );
  return data;
});
